export const checkLoginUser = () => {
    return (
        localStorage.getItem("isap_cognitouser_client") !== null ? (true) : (false)
    )
}